angular
  .module('services.ApiService', [])
  .service('ApiService', [
    '$http',
    'SpinnerService',
    '$q',
    function($http, Spinner, $q) {
      var api = {
        always_spinner: false
      };

      /**
       * Shows the spinner if specified by the value of always_spinner
       * variable or the spinner parameter
       *
       * @param {string} key - URL to do the request
       * @param {boolean} spinner - Flag to control the spinner, if true it
       *                            shows it, if false it doesn't and it not
       *                            defined depends of alwsys_spinner variable
       */
      var addSpinnerFlag = function(key, spinner) {
        if(spinner || (api.always_spinner && spinner !== false)) {
          Spinner.addFlag(key);
        }
      };

      /**
       * Performs a GET requests to a given URL
       *
       * @param {string} url - URL to do the request
       * @param {boolean} spinner - Flag to control the spinner status
       *
       * @returns {object} - Request promise object
       */
      api.get = function(url, spinner) {
        addSpinnerFlag(url, spinner);

        var promise = $http.get(url);

        promise.finally(function() {
          Spinner.markFlag(url);
        });

        return promise;
      };

      /**
       * Performs a POST request to a given URL. If there is no defined data
       * for the request body it rejects the promise
       *
       * @param {object} params - Params object with the following fields
       *                          url: string - URL to do the request
       *                          data: object - Key/value json-like object
       *                          spinner: Flag to control the spinner status
       *
       * @returns {object} - Request promise object
       */
      api.post = function(params) {
        var promise;

        if(params.data) {
          addSpinnerFlag(params.url, params.spinner);

          promise = $http.post(params.url, params.data);

          promise.finally(function() {
            Spinner.markFlag(params.url);
          });
        } else {
          promise = $q(function(resolve) {
            resolve($q.reject({
              'error': 'No data to send'
            }));
          });
        }

        return promise;
      };

      /**
       * Performs a update (PUT/PATCH) request to a given URL. If there is no
       * defined data for the request body it rejects the promise
       *
       * @param {object} params - Params object with the following fields
       *                          method: string - 'PUT' or 'PATCH'
       *                          url: string - URL to do the request
       *                          data: object - Key/value json-like object
       *                          spinner: Flag to control the spinner status
       *
       * @returns {object} - Request promise object
       */
      api.update = function(params) {
        var promise;

        if(params.data) {
          addSpinnerFlag(params.url, params.spinner);

          promise = $http(params);

          promise.finally(function() {
            Spinner.markFlag(params.url);
          });
        } else {
          promise = $q(function(resolve) {
            resolve($q.reject({
              'error': 'No data to update'
            }));
          });
        }

        return promise;
      };

      /**
       * Performs a delete request to a given URL
       *
       * @param {string} url - URL to do the request
       * @param {boolean} spinner - Flag to control the spinner status
       * @returns {object} - Request promise object
       */
      api.delete = function(url, spinner) {
        addSpinnerFlag(url, spinner);

        var promise = $http.delete(url);

        promise.finally(function() {
          Spinner.markFlag(url);
        });

        return promise;
      };

      return api;
    }
  ]);
